"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _commons = require("egov-ui-kit/utils/commons");

var _components = require("components");

var _arrowDropDown = require("material-ui/svg-icons/navigation/arrow-drop-down");

var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);

var _translationNode = require("egov-ui-kit/utils/translationNode");

var _translationNode2 = _interopRequireDefault(_translationNode);

var _get = require("lodash/get");

var _get2 = _interopRequireDefault(_get);

var _commons2 = require("../../../utils/commons");

var _commons3 = require("egov-ui-framework/ui-utils/commons");

require("./index.css");

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CityPickerDialog = function (_Component) {
  (0, _inherits3.default)(CityPickerDialog, _Component);

  function CityPickerDialog() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CityPickerDialog);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CityPickerDialog.__proto__ || Object.getPrototypeOf(CityPickerDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = { results: [], searchTerm: "", open: false }, _this.getLocalizedLabel = function (label) {
      var localizationLabels = _this.props.localizationLabels;

      return (0, _commons2.getTranslatedLabel)(label, localizationLabels);
    }, _this.prepareResultsForDisplay = function () {
      var results = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      results = results.map(function (result, index) {
        var mappedResult = {};
        mappedResult.key = result.key;
        mappedResult.primaryText = _this.getLocalizedLabel("TENANT_TENANTS_" + result.key.toUpperCase().replace(/[.:-\s\/]/g, "_"));
        mappedResult.id = result.key;
        return mappedResult;
      });
      return results.sort(function (e1, e2) {
        if (e1 && e1.primaryText && typeof e1.primaryText == 'string') {
          return e1 && e1.primaryText && e1.primaryText.localeCompare && e1.primaryText.localeCompare(e2 && e2.primaryText && e2.primaryText || '');
        } else if (e1 && e1.key && typeof e1.key == 'string') {
          return e1 && e1.key && e1.key.localeCompare && e1.key.localeCompare(e2 && e2.key && e2.key || '');
        } else {
          return 1;
        }
      });
    }, _this.onCityFieldClicked = function () {
      _this.setState({
        open: true,
        searchTerm: ""
      }, function () {
        setTimeout(function () {
          document.querySelectorAll(".citipicker-choose-label").forEach(function (child) {
            var parent = child.parentElement;
            if (parent && !parent.classList.contains("has-label-container")) {
              parent.classList.add("has-label-container");
            }
          });
        }, 50);
      });
    }, _this.onClose = function () {
      _this.setState({ open: false });
    }, _this.onItemClick = function (item, index) {
      var key = item.key;

      if (key) {
        var _this$props = _this.props,
            fieldKey = _this$props.fieldKey,
            onChange = _this$props.onChange;

        onChange(fieldKey, key);
        _this.onClose();
      }
    }, _this.autoSuggestCallback = function () {
      var results = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var searchTerm = arguments[1];
      var cities = _this.props.cities;
      // Handle empty search term

      if (searchTerm.length === 0) {
        _this.setState({ results: cities, searchTerm: searchTerm });
        return;
      }
      if (searchTerm) {
        var filteredCities = cities && cities.filter(function (item) {
          var cityName = item.text || "";
          return cityName.toLowerCase().includes(searchTerm.toLowerCase());
        });
        if (results.length === 0) {
          results.push({ key: "", text: "No City Found" });
        }
        _this.setState({ results: filteredCities, searchTerm: searchTerm });
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CityPickerDialog, [{
    key: "componentWillUnmount",


    // componentDidMount = async () => {
    //   document.getElementById("person-city").addEventListener("focus", function() {
    //     this.blur();
    //   });
    // };

    // componentDidMount() 
    // {
    //   // Safely apply class to parent of all elements with the .citipicker-choose-label class
    //   document.querySelectorAll(".citipicker-choose-label").forEach((child) => {
    //     const parent = child.parentElement;
    //     if (parent) {
    //       parent.classList.add("has-label-container");
    //     }
    //   })
    // };


    value: function componentWillUnmount() {
      document.getElementById("person-city").removeEventListener("focus", null);
    }
  }, {
    key: "render",
    value: function render() {
      var autoSuggestCallback = this.autoSuggestCallback,
          prepareResultsForDisplay = this.prepareResultsForDisplay,
          onClose = this.onClose,
          onCityFieldClicked = this.onCityFieldClicked,
          onItemClick = this.onItemClick;
      var _state = this.state,
          results = _state.results,
          searchTerm = _state.searchTerm,
          open = _state.open;
      var _props = this.props,
          field = _props.field,
          localizationLabels = _props.localizationLabels,
          cities = _props.cities;

      var displayInitialList = searchTerm.length === 0 ? true : false;
      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "div",
          { onClick: onCityFieldClicked },
          _react2.default.createElement(_components.TextFieldIcon, (0, _extends3.default)({}, field, {
            errorStyle: { bottom: "0px" },
            value: (0, _commons.getCityNameByCode)((field || {}).value, localizationLabels),
            id: "person-city",
            className: field && field.value ? "city-selected" : "without-city-selected",
            iconPosition: "after",
            Icon: _arrowDropDown2.default,
            iconStyle: {
              position: "absolute",
              color: "#969696",
              zIndex: 2,
              bottom: 0,
              top: 10
              //  margin: "auto",
            }
          }))
        ),
        _react2.default.createElement(
          _components.Dialog,
          {
            className: "citipicker-dialog",
            titleStyle: { textAlign: "left", padding: "24px 16px" },
            handleClose: onClose,
            bodyStyle: { padding: "0px", overflowX: "hidden", maxHeight: "100%", minHeight: "100px" },
            title: _react2.default.createElement(
              "div",
              { className: "citipicker-choose-label", style: { padding: '0px' } },
              _react2.default.createElement(_translationNode2.default, { label: "Choose ULB", fontSize: "16px", bold: true, color: "#484848", containerStyle: { padding: "20px 10px", backgroundColor: "#fff" } })
            ),
            modal: false,
            open: open,
            autoScrollBodyContent: true,
            onRequestClose: onClose,
            contentStyle: { width: "90%" },
            style: {
              paddingTop: "0",
              marginTop: "-30px",
              bottom: "0",
              height: "auto"
            },
            isClose: true
          },
          _react2.default.createElement(_components.AutoSuggest, {
            id: "city-picker-search",
            dataSource: cities,
            searchInputText: _react2.default.createElement(_translationNode2.default, {
              label: "Search ULB",
              color: "#727272", labelStyle: { display: "flex", justifyContent: "left" } }),
            searchKey: "text",
            autoFocus: true,
            callback: autoSuggestCallback
          }),
          _react2.default.createElement(_components.List, {
            onItemClick: onItemClick,
            innerDivStyle: { paddingLeft: "50px", color: "#484848" },
            listItemStyle: { borderBottom: "1px solid #eee", color: "#484848" },
            items: displayInitialList ? prepareResultsForDisplay(cities) : prepareResultsForDisplay(results)

          })
        )
      );
    }
  }]);
  return CityPickerDialog;
}(_react.Component);

var mapStateToProps = function mapStateToProps(state) {
  var cities = state.common.cities || [];
  var localizationLabels = (0, _get2.default)(state.app, "localizationLabels", {});
  return { cities: cities, localizationLabels: localizationLabels };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(CityPickerDialog);


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/common/common/CityPicker/index.js
// module id = ../lib/egov-ui-kit/common/common/CityPicker/index.js
// module chunks = 504